import { Component } from "@kluntje/core";
import { ACTIVE, INACTIVE } from "Helper/cssClasses";
import {addClass, find, hasClass, removeClass} from "@kluntje/js-utils/lib/dom-helpers";

/**
 * Custom Element to .. @TODO
 */
class FRAToggle extends Component {
  constructor() {
    super({
      ui: {
        option: ".fra-e-toggle__option",
      },

      events: [
        {
          event: "click",
          target: "option",
          handler: "handleClick",
        },
        {
          event: "keydown",
          target: "option",
          handler: "handleKeyDown",
        },
      ],
    });
  }

  afterComponentRender() {
    if (hasClass(this, "fra-e-toggle--default-second")) {
      addClass(this.ui.option[1], ACTIVE);
      addClass(this.ui.option[0], INACTIVE);
    } else {
      addClass(this.ui.option[0], ACTIVE);
      addClass(this.ui.option[1], INACTIVE);
    }
  }

  handleKeyDown(event: Event) {
    if (event instanceof KeyboardEvent && event.key !== "Enter" && event.key !== " ") {
      return;
    }
    this.handleClick();
    const target = event.currentTarget as HTMLElement;
    if (target && target.parentElement) target.parentElement.click();
  }

  handleClick(): void {
    const active = find(this, ".fra-state-active");
    const inactive = find(this, ".fra-state-inactive");
    removeClass(active, ACTIVE);
    removeClass(inactive, INACTIVE);
    addClass(inactive, ACTIVE);
    addClass(active, INACTIVE);
  }
}

customElements.define("fra-e-toggle", FRAToggle);

export default FRAToggle;
